import { useQueryClient, useQuery } from '@gogame/query';

import {
  loadActivities,
  loadMetrics,
  loadTraffics,
  loadGenres,
  loadApplications,
  loadNetworks,
  loadPlatforms,
  loadCountries,
  loadRegistrations,
  loadFrauds,
} from 'scenes/KPI/sources/fields';

import {
  ACTIVITY,
  APPLICATIONS,
  COUNTRIES,
  GENRES,
  METRIC,
  NETWORKS,
  PLATFORMS,
  REGISTRATIONS,
  TRAFFIC,
  FRAUD,
} from '../components/KPIForm/constants';
import { grids } from './queryKeyFactory';

export const useUpdateSeriesPreview = () => {
  const queryClient = useQueryClient();
  const getSeriesPreview = useGetSeriesPreview();
  return function handleUpdate(series) {
    queryClient.setQueriesData(
      {
        queryKey: grids(),
        exact: false,
      },
      (oldData = {}) => {
        const { rows = [], warnings = [] } = oldData;

        const newRows = series.map((s) => {
          const row = rows.find((row) => row.id === s.id);
          if (s.dirty || !row) {
            return getSeriesPreview(s);
          }
          return row;
        });

        return {
          rows: newRows,
          warnings,
        };
      }
    );
  };
};

function getLabel(lookups, value) {
  return lookups?.find(({ id }) => id === value);
}

const ALL = [{ name: 'All' }];

export function useGetSeriesPreview() {
  const { data: frauds } = useQuery('fraudType', (_, { signal }) =>
    loadFrauds({}, { signal })
  );
  const { data: activities } = useQuery('activities', (_, { signal }) =>
    loadActivities({}, { signal })
  );
  const { data: metrics } = useQuery('metrics', (_, { signal }) =>
    loadMetrics({}, { signal })
  );
  const { data: traffics } = useQuery('traffics', (_, { signal }) =>
    loadTraffics({}, { signal })
  );
  const { data: genres } = useQuery('genres', (_, { signal }) =>
    loadGenres({}, { signal })
  );
  const { data: applications } = useQuery('applications', (_, { signal }) =>
    loadApplications({}, { signal })
  );
  const { data: networks } = useQuery('networks', (_, { signal }) =>
    loadNetworks({}, { signal })
  );
  const { data: platforms } = useQuery('platforms', (_, { signal }) =>
    loadPlatforms({}, { signal })
  );
  const { data: countries } = useQuery('countries', (_, { signal }) =>
    loadCountries({}, { signal })
  );
  const { data: registrations } = useQuery('registrations', (_, { signal }) =>
    loadRegistrations({}, { signal })
  );

  return function getPreview(model) {
    return {
      dirty: model.dirty,
      id: model.id,
      activityType: getLabel(activities, model[ACTIVITY]),
      metric: getLabel(metrics, model[METRIC]),
      trafficType: getLabel(traffics, model[TRAFFIC]),
      botRegistrationType: getLabel(registrations, model[REGISTRATIONS]),
      fraudType: getLabel(frauds, model[FRAUD]),
      genres: model[GENRES]?.map((v) => getLabel(genres, v)) || ALL,
      applications:
        model[APPLICATIONS]?.map((v) => getLabel(applications, v)) || ALL,
      networks: model[NETWORKS]?.map((v) => getLabel(networks, v)) || ALL,
      platforms: model[PLATFORMS]?.map((v) => getLabel(platforms, v)) || ALL,
      countries: model[COUNTRIES]?.map((v) => getLabel(countries, v)) || ALL,
    };
  };
}
